export default __webpack_public_path__ + "static/1-0bbc300af620668694376319f8b6d3ec.png";